import React from 'react';
import "bootstrap/dist/css/bootstrap.min.css";
import { Link, NavLink } from 'react-router-dom';
import "./LoginPage.css";
import { FcGoogle } from "react-icons/fc";
import { BsMicrosoft } from "react-icons/bs";
import 'boxicons/css/boxicons.min.css';
import { Button } from 'react-bootstrap';

const LoginPage = () => {


    return (
        <div className="d-flex align-items-center justify-content-center lg_vh">
            <form className="shadow-sm login-container">
                <div className="form-header text-center mb-4">
                    <h2>Welcome Back</h2>
                    <p>Please login to your account</p>
                </div>

                <div className="mb-4">
                    <div className="input-group">
                        <span className="input-group-text"><i className="bx bxs-user"></i></span>
                        <input
                            type="email"
                            className="form-control"
                            placeholder="Work Email Address"
     value=""
                        />
                    </div>
                </div>

                <div className="mb-4">
                    <div className="input-group">
                        <span className="input-group-text"><i className="bx bxs-lock"></i></span>
                        <input
                            type="password"
                            className="form-control"
                            placeholder="Password"
                            value=""
                        />
                    </div>
                </div>






<div className="mb-4 d-flex flex-column flex-md-row justify-content-start justify-content-md-between align-items-start">
  <div className="form-check">
    <input type="checkbox" className="form-check-input" id="rememberMe" />
    <label className="form-check-label" htmlFor="rememberMe">Remember me</label>
  </div>
  <NavLink to="/forgot-password" className="text-decoration-none text-primary mt-2 mt-md-0">
    Forgot password?
  </NavLink>
</div>





              <NavLink to="/MainDashboard" className="btn btn-primary w-100 py-3">Continue</NavLink>

                <div className="text-center my-3">
                    <span>or continue with</span>
                </div>


<div className="d-flex flex-column gap-3">
  <button type="button" className="btn social-btn d-flex align-items-center justify-content-center p-3 w-100 border border-secondary text-dark">
    <FcGoogle className="me-2" size={20} /> Continue with Google
  </button>
  <button type="button" className="btn social-btn d-flex align-items-center justify-content-center p-3 w-100 border border-secondary text-dark">
    <BsMicrosoft className="me-2 text-primary" size={20} /> Continue with Microsoft
  </button>
</div>

<div className="text-center mt-4">
                    <p className="p-0 m-0">Don't have an account?<Button variant="btn-primary" as={Link} to="/SignupPage" className="px-2 text-primary text-decoration-none">Sign up</Button></p>
                </div>

            </form>
        </div>
    );
};

export default LoginPage;
